import { useParams } from "react-router-dom";
import DynamicFormRemote from "@/components/DynamicFormRemote";

export default function RemoteFormPage() {
  const { slug } = useParams<{ slug: string }>();
  
  if (!slug) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold">Missing Form Slug</h1>
          <p className="text-muted-foreground mt-2">
            Please provide a valid form identifier in the URL
          </p>
        </div>
      </div>
    );
  }

  return <DynamicFormRemote slug={slug} />;
}
